module.exports = __webpack_public_path__ + "static/media/Spotifyicon.7a34cf42.png";